import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const ImageCtaBase = styled.section`
  border-radius: 0.5rem;
  background-color: ${theme.colors.blues[10]};
`;

export const Container = styled.div``;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1rem;

  ${theme.largerThan.lg} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2rem;
  }
`;

export const PrimaryCopy = styled.div`
  text-align: center;
  ${theme.largerThan.lg} {
    text-align: left;
    padding-bottom: 2rem;

    h2:after {
      content: "";
      display: block;
      width: 4rem;
      height: 2px;
      margin-top: 1rem;
      background-color: ${theme.colors.darkGreen};
    }
  }

  p.paragraph {
    margin: 1.5rem 0;
    font-size: ${theme.fontSizes[2]};
    line-height: 1.5;
    font-weight: 400;
    color: ${theme.colors.darkBlues[100]};
  }
  ul {
    font-size: ${theme.fontSizes[2]};
    line-height: 1.5;
    font-weight: 400;
  }
`;

export const PrimaryImage = styled.div`
  ${theme.largerThan.md} {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  .gatsby-image-wrapper img {
    object-fit: contain !important;
  }
`;

export const CTAStyled = styled(CTA)`
  width: fit-content;
  align-self: center;
  padding: 12px 16px !important;

  ${theme.largerThan.sm} {
    align-self: initial;
  }
`;
